import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance
const api = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor to include JWT token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 errors (token expired)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Auto logout if 401 response returned from api
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Form CRUD operations
export const getForms = async () => {
    const response = await api.get(`${API_URL}/form-data`);
    return response.data;
};

export const getFormById = async (id) => {
    const response = await api.get(`${API_URL}/form-data/${id}`);
    return response.data;
};

export const getFormByFormId = async (formId) => {
    const response = await api.get(`${API_URL}/form-data/custom/${formId}`);
    return response.data;
};

export const createForm = async (formData) => {
    const response = await api.post(`${API_URL}/form-data`, formData);
    return response.data;
};

export const updateForm = async (id, formData) => {
    const response = await api.put(`${API_URL}/form-data/${id}`, formData);
    return response.data;
};

export const deleteForm = async (id) => {
    const response = await api.delete(`${API_URL}/form-data/${id}`);
    return response.data;
};

export const searchForms = async (queryParams) => {
    // Convert query params object to URL query string
    const queryString = new URLSearchParams(queryParams).toString();
    const response = await api.get(`${API_URL}/form-data/search/query?${queryString}`);
    return response.data;
};

// Additional utility for form fields
export const getFieldTypes = () => {
    return [
        { value: 'text', label: 'Text' },
        { value: 'email', label: 'Email' },
        { value: 'tel', label: 'Telephone' },
        { value: 'number', label: 'Number' },
        { value: 'date', label: 'Date' },
        { value: 'textarea', label: 'Text Area' },
        { value: 'select', label: 'Dropdown' },
        { value: 'radio', label: 'Radio Buttons' },
        { value: 'checkbox', label: 'Checkbox' }
    ];
};